export const theme = {
  colors: {
    background: '#0a192f',
    backgroundLight: '#112240',
    surface: '#172a46',
    primary: '#64ffda',
    primarySoft: '#9affea',
    text: '#ccd6f6',
    textSecondary: '#8892b0',
    white: '#ffffff',
  },
  fonts: {
    main: "'Inter', -apple-system, system-ui, sans-serif",
    mono: "'Fira Code', 'Courier New', monospace",
  },
  transitions: {
    default: 'all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
};
